import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { SurveyComponent } from './survey/survey.component';
import { QuestionComponent } from './survey/question/question.component';
import { YesNoQuestionComponent } from './survey/question/yes-no-question/yes-no-question.component';
import { SelectQuestionComponent } from './survey/question/select-question/select-question.component';
import { EssayQuestionComponent } from './survey/question/essay-question/essay-question.component';
import { RatingQuestionComponent } from './survey/question/rating-question/rating-question.component';
import { ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { RatingPageRoutingModule } from './rating-routing.module';

import { RatingPage } from './rating.page';

import { IonicRatingComponentModule } from 'ionic-rating-component';

import { FormsModule } from '@angular/forms';

import { NgMeta } from 'ngmeta';

@NgModule({
  imports: [
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    RatingPageRoutingModule,
    IonicRatingComponentModule
  ],
  declarations: [
    RatingPage, 
    SurveyComponent,
    QuestionComponent,
    YesNoQuestionComponent,
    SelectQuestionComponent,
    EssayQuestionComponent,
    RatingQuestionComponent,
  ]
})
export class RatingPageModule {}
